import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function SingleSpeakerAndSlidesIcon(props) {
  return (
    <SvgIcon {...props} viewBox='0 0 32 32'>
      {/* Left Frames (Single webcam frame) */}
      <rect
        x='0'
        y='13'
        width='8'
        height='6'
        rx='0'
        fill='white'
        stroke='white'
        strokeWidth='2'
      />
      {/* Right Frame (Screenshare) */}
      <rect
        x='10'
        y='6'
        width='20'
        height='20'
        rx='2'
        fill='none'
        stroke='white'
        strokeWidth='2'
      />
    </SvgIcon>
  );
}

export default SingleSpeakerAndSlidesIcon;
